import { type HTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";
import { cva, type VariantProps } from "@/shared/lib/variants";

/**
 * Compact chip used for tags, status pills, and inline metadata. Carries
 * the editorial label cadence — type-label-sm, tracking-wider, uppercase,
 * rounded-full — so badges read as deliberate labels rather than buttons.
 */
const badge = cva(
  [
    "inline-flex items-center gap-1",
    "rounded-full type-label-sm tracking-wider uppercase",
    "px-3 py-2",
  ],
  {
    variants: {
      variant: {
        default: "glass-surface-subtle text-text",
        muted: "bg-surface-muted/40 text-text-muted",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badge> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badge({ variant }), className)} {...props} />;
}
